import SearchBarFilter from './SearchBarFilter';

export default SearchBarFilter;
